import { useCallback } from "react";
import { useNavigate, NavigateOptions, To } from "react-router-dom";
import { ONBOARDING_PATH, ROOT_PATH } from "../../routes/constants";

export const useCustomNavigate = () => {
  const navigate = useNavigate();

  const customNavigate = useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === "number" && to === -1) {
        const currentPath = window.location.pathname;
        navigate(-1 as To, options);
        // Check if URL changed after a short delay
        setTimeout(() => {
          if (window.location.pathname === currentPath) {
            // If URL didn't change, navigate to candidate-home
            navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/candidate-home`, options);
          }
        }, 100); // Small delay to allow navigation to process
      } else {
        // Handle regular navigation
        navigate(to as To, options);
      }
    },
    [navigate],
  );

  return customNavigate;
};
